var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"progress":_vm.progress,"color":_vm.progressColor,"empty-color":"transparent","size":_vm.progressSize,"legend":true,"legendValue":_vm.progress,"legendFormatter":function (ref) {
	var currentValue = ref.currentValue;

	return (" <small class='d-block'>" + currentValue + "%</small>");
},"legendClass":"legend-custom-style","thickness":3,"empty-thickness":"1","lineMode":"out 2","animation":"rs 700 1000","fontSize":"1.2rem"}})}
var staticRenderFns = []

export { render, staticRenderFns }